import * as React from "react";
import { ISpinner } from "src/ScrollyInterface";
import "./Spinner.scss";

const spinner = (props: ISpinner) =>
  props.hide ? null : (
    <div className="Scrolly-loader-container">
      <div className="Scrolly-loader" />
    </div>
  );

export default spinner;



// WEBPACK FOOTER //
// ./src/UI/Spinner.tsx